/* eslint-disable prettier/prettier */
import Colors from "@constants/Colors";
import styled from "styled-components";

export const TotalSalesWrapper = styled.div`
  margin: "8px";
`;

export const TotalSalesValueWrapper = styled.div`
  margin-top: 4px;
  word-wrap: break-word;
`;

export const EventTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px 8px;
  gap: 10px;
  margin: 8px 0px;
  background: ${Colors.neutral_gray_100};
  border-radius: 4px;
  .customColor {
    color: ${Colors.primary};
  }
  .customSubTitle {
    font-family: Ringside Regular-Book;
    color: ${Colors.primary};
  }
`;

export const CustomTitle = styled.div<{
  isCurrent: boolean;
}>`
  padding: 0px 8px;
  max-width: 52px;
  width: 100vw;
  height: 20px;
  background: ${(props) =>
    props?.isCurrent ? Colors.secondarypurple_100 : Colors.success_50};
  border-radius: 4px;
  .customTitle {
    font-family: Ringside Regular-Bold;
    color: ${(props) =>
      props?.isCurrent ? Colors.secondarypurple_700 : Colors.success_600};
    text-transform: capitalize;
  }
`;

export const TotalSalesCardWrapper = styled.div`
  .title {
    text-transform: capitalize;
    color: ${Colors.neutralblack};
  }
`;
